import { render, staticRenderFns } from "./BulkPointActions.vue?vue&type=template&id=798e44c2&"
import script from "./BulkPointActions.vue?vue&type=script&lang=js&"
export * from "./BulkPointActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkPointActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports